import type { CockpitRepRow } from '../../../types';
import { isByTypeKey, typeCount, typeOfKey, type ActivityTypeSortKey } from './activityTypes';

export type SortKey =
  | 'displayName' | 'lastSeen'
  | 'raisedThisSyCents' | 'raisedPriorSyCents' | 'fundraiserYoyPct' | 'campaignsThisSy'
  | 'activitiesTotal' | ActivityTypeSortKey | 'onsite' | 'onsiteFlagged' | 'contactsTouched' | 'overdue' | 'conversions'
  | 'peopleOwned' | 'namedAccountsOwned';

export type SortDir = 'asc' | 'desc';

function cmpValue(r: CockpitRepRow, key: SortKey): string | number | bigint {
  if (isByTypeKey(key)) return typeCount(r, typeOfKey(key));
  switch (key) {
    case 'displayName': return (r.displayName ?? '').toLowerCase();
    case 'lastSeen': return r.lastSeen ? new Date(r.lastSeen).getTime() : Number.NEGATIVE_INFINITY;
    case 'raisedThisSyCents': return BigInt(r.raisedThisSyCents);
    case 'raisedPriorSyCents': return BigInt(r.raisedPriorSyCents);
    case 'fundraiserYoyPct': return r.fundraiserYoyPct ?? Number.NEGATIVE_INFINITY;
    default: return r[key] as number;
  }
}

export function sortRepRows(rows: CockpitRepRow[], key: SortKey, dir: SortDir): CockpitRepRow[] {
  const sorted = [...rows].sort((a, b) => {
    const av = cmpValue(a, key);
    const bv = cmpValue(b, key);
    let c: number;
    if (typeof av === 'bigint' && typeof bv === 'bigint') c = av < bv ? -1 : av > bv ? 1 : 0;
    else if (typeof av === 'string' && typeof bv === 'string') c = av.localeCompare(bv);
    else c = (av as number) - (bv as number);
    return dir === 'asc' ? c : -c;
  });
  return sorted;
}
